import { Download } from "lucide-react";
import type React from "react";
import { useTranslation } from "react-i18next";

interface DownloadActionProps {
  href: string;
  fileName: string;
  className?: string;
}

export const DownloadAction: React.FC<DownloadActionProps> = ({
  href,
  fileName,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <a
      href={href}
      download={fileName}
      className={className}
      title={t("common.download")}
      aria-label={t("common.downloadWithName", { name: fileName })}
      onClick={(event) => event.stopPropagation()}
    >
      <Download className="size-4" />
    </a>
  );
};
